(function () {
  var replacements = [
    [/Orders under R\s?1,?000 carry a flat R80 shipping rate\./gi, 'Orders under R600 carry a flat R80 shipping rate.'],
    [/Orders under R\s?1\s000 carry a flat R80 shipping rate\./gi, 'Orders under R600 carry a flat R80 shipping rate.'],
    [/Free shipping over R\s?1,?000/gi, 'Free shipping over R600'],
    [/Free shipping over R\s?1\s000/gi, 'Free shipping over R600']
  ];

  function fixTextNode(node) {
    var text = node.nodeValue;
    var updated = text;
    replacements.forEach(function (pair) {
      updated = updated.replace(pair[0], pair[1]);
    });
    if (updated !== text) node.nodeValue = updated;
  }

  function walkAndFix(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(fixTextNode);
  }

  function run() { walkAndFix(document.body); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('cart:update', run);
  document.addEventListener('shopify:section:load', run);
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) fixTextNode(node);
        else if (node.nodeType === Node.ELEMENT_NODE) walkAndFix(node);
      });
    });
  });
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
})();
